import { Component} from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner.service';


@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {


  constructor(private spinner: SpinnerService) { }

  get switch() {
    return this.spinner.state;
  }

}



